// directives/v-viewer.js
import Viewer from 'viewerjs'

export default {
  bind(el, binding) {
    const viewerOptions = binding.value || {}; // 获取传入的选项参数
    new Viewer(el, viewerOptions); // 初始化Viewer实例
  }
}



// WEBPACK FOOTER //
// ./src/directives/v-viewer.js